module.exports = __webpack_public_path__ + "img/icon-chevron-down.5c148ba2.svg";